<div class="user-panel">
  <div class="user-info">
    <i class="dx-icon dx-icon-user"></i>
    <span class="user-name">{{username}}</span>
  </div>
  <dx-context-menu
    *ngIf="menuMode === 'context'"
    (onShowing)="initMenuItems()"
    [items]="menuItems"
    target=".user-button"
    showEvent="dxclick"
    width="210px"
    [position]="{
      my: 'top',
      at: 'bottom'
    }"
    cssClass="user-menu">
  </dx-context-menu>
  <dx-list
    *ngIf="menuMode === 'list'"
    class="dx-toolbar-menu-action"
    (onContentReady)="initMenuItems()"
    [items]="menuItems">
  </dx-list>
</div>
